/* RAW RIDE - nouveau site (proposition Pablo Consulting, 01.10.2026) : petites interactions. */
(() => {
  // Produit en precommande : le bouton d'achat dit « Précommander » (le theme remet « Ajouter au
  // panier » a chaque changement de taille, on le reecrit donc a chaque fois).
  if (window.rrPreorder) {
    // Le libelle arrive dans la langue du visiteur (cle rr.preorder.button, posee par rr-pdp-proof.liquid) ;
    // le texte a remplacer est celui que le theme annonce lui-meme pour « ajouter au panier ».
    const libelle = typeof window.rrPreorder === 'string' ? window.rrPreorder : 'Précommander';
    const ajout = ((window.variantStrings && window.variantStrings.addToCart) || '').trim().toLowerCase();
    // ⚠ DEFAUT PAYE le 12.10.2026 : quand le libelle voulu est devenu « Ajouter au panier » (le meme que celui du
    // theme), chaque reecriture declenchait l'observateur, qui reecrivait, sans fin : la fiche du hoodie se FIGEAIT
    // (site publie de 19h05 a 20h45, heure suisse). Deux parades : on n'ecrit JAMAIS un texte deja bon, et si le
    // libelle voulu est celui du theme on ne surveille rien du tout.
    const voulu = libelle.trim();
    const fixer = () => {
      document.querySelectorAll('product-form .product-form__submit span:not(.rr-keep), [data-rr-sticky-btn] span').forEach((s) => {
        const brut = s.textContent.trim();
        if (brut === voulu) return;
        const t = brut.toLowerCase();
        if ((ajout && t === ajout) || t.startsWith('ajouter') || t.startsWith('add to')) s.textContent = voulu;
      });
    };
    const memeQueLeTheme = voulu.toLowerCase() === ajout || /^(ajouter au panier|add to cart)$/i.test(voulu);
    if (!memeQueLeTheme) {
      fixer();
      const cible = document.querySelector('product-form');
      if (cible) new MutationObserver(fixer).observe(cible, { childList: true, subtree: true, characterData: true });
    }
  }

  // Apercu de theme uniquement : Shopify pose sa barre « Draft » en bas de l'ecran, par-dessus la barre
  // d'achat collante et le bouton de paiement du tiroir panier. On mesure sa hauteur dans --rr-apercu
  // (lue par rr-v2.css) ; sur le site publie cette barre n'existe pas : la fonction sort tout de suite.
  let apercuSuivi = false;
  let apercuHauteur = -1;
  const mesurerApercu = () => {
    const pb = document.getElementById('PBarNextFrameWrapper');
    if (!pb) return;
    const r = pb.getBoundingClientRect();
    const h = r.height > 0 && r.bottom >= window.innerHeight - 2 ? Math.round(r.height) : 0;
    if (h !== apercuHauteur) {
      apercuHauteur = h;
      document.documentElement.style.setProperty('--rr-apercu', h + 'px');
    }
    if (!apercuSuivi) {
      apercuSuivi = true; // la barre peut etre masquee (« Hide bar ») ou changer de taille : on la suit
      if (window.ResizeObserver) new ResizeObserver(mesurerApercu).observe(pb);
      window.addEventListener('resize', mesurerApercu);
    }
  };
  [0, 600, 1500, 3000, 6000].forEach((d) => setTimeout(mesurerApercu, d)); // la barre arrive apres le chargement

  // Fiche produit : l'option « Taille de l'accessoire » s'affiche « Taille » (affichage seulement ; le nom de
  // l'option dans la boutique ne change pas). Filet de securite : le theme la renomme deja cote serveur, mais
  // le nom de l'option est ecrit avec une apostrophe typographique que ce remplacement ne reconnait pas.
  const info = document.querySelector('product-info');
  if (info) {
    const renommer = () => {
      info.querySelectorAll('.product-form__input .form__label').forEach((l) => {
        const n = l.firstChild;
        if (n && n.nodeType === 3 && /^\s*Taille de l.accessoire\s*$/i.test(n.textContent)) n.textContent = 'Taille';
      });
    };
    renommer();
    new MutationObserver(renommer).observe(info, { childList: true, subtree: true });
  }

  // Barre d'achat collante (mobile) sur la fiche produit
  const bar = document.querySelector('[data-rr-sticky]');
  if (bar) {
    const main = document.querySelector('product-form .product-form__submit') ||
      document.querySelector('form[action*="/cart/add"] [type="submit"]');
    const btn = bar.querySelector('[data-rr-sticky-btn]');
    const picker = document.querySelector('variant-selects, variant-radios, .product-form__input');
    // Defilement doux, sauf si le visiteur a demande moins d'animations
    const doux = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
    if (!main || !btn) {
      bar.remove();
    } else {
      const io = new IntersectionObserver(([e]) => {
        const out = !e.isIntersecting && e.boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', out);
        bar.setAttribute('aria-hidden', out ? 'false' : 'true');
        btn.tabIndex = out ? 0 : -1;
      }, { threshold: 0 });
      io.observe(main);
      btn.addEventListener('click', (ev) => {
        ev.preventDefault();
        if (bar.dataset.choice === 'true' && picker) {
          picker.scrollIntoView({ behavior: doux, block: 'center' });
          picker.classList.add('rr-flash');
          setTimeout(() => picker.classList.remove('rr-flash'), 1400);
          return;
        }
        if (main.disabled) { main.scrollIntoView({ behavior: doux, block: 'center' }); return; }
        main.click();
      });
    }
  }
})();
